module.exports = __webpack_public_path__ + "static/media/1pay.f5a496fb.svg";